import { Component, Prop, Vue } from 'vue-property-decorator'
import BadgePerson from '@/components/BadgePerson/index.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faClock,
	faChartSimple,
	faInbox,
	faAt,
	faClipboardList,
	faHourglassEnd,
	faFileCircleCheck,
	faPersonWalking,
} from '@fortawesome/free-solid-svg-icons'
import { Auditoria } from '@/types/auditoria'
import { bus } from '@/main'

library.add(faClock, faInbox, faAt, faClipboardList, faChartSimple, faHourglassEnd, faFileCircleCheck, faPersonWalking)

@Component({ components: { BadgePerson } })
export default class CardAuditoria extends Vue {
	@Prop({ required: true }) auditoria!: Auditoria

	get statusClass(): string {
		switch (this.auditoria.status) {
			case 'Concluído': return 'alert-success'
			case 'Pendente': return 'alert-warning'
			case 'Em andamento': return 'alert-info'
			case 'Atrasado': return 'alert-danger'
			default: return 'alert-secondary'
		}
	}

	formatDate(dateStr: string | null): string {
		if (!dateStr) return '—'
		const [year, month, day] = dateStr.split('-')
		if (!year || !month || !day) return dateStr
		return `${day}/${month}/${year}`
	}

	openAuditoria() {
		bus.$emit('open-modal-auditoria-edit', this.auditoria)
	}
}
